import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { UnitMeasureTypeService } from '../../../core/services/tax-document/tax-document-type/unit-measure-type.service'
import { ExamTypeService } from '../../../core/services/exam-type/document-type/exam-type.service'
import {MessageTypeService} from '../../../core/services/message-type/document-type/message-type.service';
import {ContentTypeService} from '../../../core/services/content-type/document-type/content-type.service';
import {MatSlideToggle} from '@angular/material/slide-toggle';

@Component({
  selector: 'content-type-edit',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatSlideToggle,
  ],
  templateUrl: './content-type-edit.component.html',
  styleUrl: './content-type-edit.component.scss',
  providers: [ExamTypeService],
  standalone: true,
})
export class ContentTypeEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private documentTypeService: ContentTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ContentTypeEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() responseEdit = new EventEmitter()

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  updateItem() {
    this.loading = true
    const model = this.createModel()
    this.documentTypeService.editContentType(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.itemEdit.id,
      descricao: this.form.controls['description'].value,
      status_id: this.form.controls['active'].value ? 1 : 2,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [this.itemEdit.id, [Validators.required]],
      description: [this.itemEdit.descricao, [Validators.required]],
      active: [this.itemEdit.status_id === 1 || this.itemEdit.status_id === "1", [Validators.required]],
    })
    this.form.get('code')?.disable()
  }
}
